/* AFTER FOUR v50 | Reading progress on editorial posts, no other sitewide tracking. */
(() => {
  'use strict';
  function initReading() {
    const meter = document.querySelector('.af50-reading-progress span');
    const article = document.querySelector('.af-article');
    if (!meter || !article) return;
    let ticking = false;
    const draw = () => {
      ticking = false;
      const start = article.getBoundingClientRect().top + window.scrollY;
      const bottom = article.getBoundingClientRect().bottom + window.scrollY;
      const distance = Math.max(1, bottom - start - window.innerHeight);
      const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
      meter.style.width = (progress * 100).toFixed(1) + '%';
    };
    const onScroll = () => {if (ticking) return; ticking = true; window.requestAnimationFrame(draw);};
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll);
    draw();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initReading,{once:true});
  else initReading();
})();